import React from 'react';
import { ImTv } from "react-icons/im";
import { GiFilmProjector } from "react-icons/gi";
import Rating from '@mui/material/Rating';
import { Tooltip } from '@mui/material';
// import Button from '@mui/material/Button';


function ResultList(props) {

    return ( 
        <div className="h-[540px] overflow-auto relative shadow-md sm:rounded-sm mb-12">
        <table className="w-full xl:w-2/3 mx-auto text-xs text-left text-gray-500 dark:text-gray-400">
            <thead className="text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                    <th scope="col" className="py-3 pl-2">
                        Type
                    </th>
                    <th scope="col" className="py-3 px-2 text-center">
                        Genre
                    </th>
                    <th scope="col" className="py-3 px-1 text-center">
                        Rating
                    </th>
                    <th scope="col" className="py-3 px-4">
                        Title
                    </th>
                    <th scope="col" className="py-3 px-2.5">
                        Current Networks
                    </th>
                </tr>
            </thead>
            <tbody>
                {props.data.slice(0,30).map((item, index)=>(
                    <tr key={index}
                        className="border-b text-xs h-12 dark:bg-gray-100 dark:border-gray-400">
                        <th scope="row" className="w-[70px] py-1 px-3 font-medium text-gray-600 whitespace-nowrap dark:text-gray-700">
                            {(item.content_type==='Show' ?
                            <ImTv className='w-5'/> 
                            : item.content_type==='Movie' ?
                            <GiFilmProjector className='text-xl w-5' />
                            :
                            null)}
                        </th>
                        <th scope="row" className="w-[100px] py-1 px-0 text-center font-medium text-gray-500 whitespace-nowrap dark:text-gray-700">
                            <p className=''>{item.genre}</p>
                        </th>
                        <th scope="row" className="w-[100px] py-1 px-0 text-center font-medium text-gray-500 whitespace-nowrap dark:text-gray-700">
                            {item.evaluation_score}
                            <div className='scale-75'>
                                <Rating name="half-rating-read"
                                        size="small"
                                        value={item.evaluation_score}
                                        precision={0.1} 
                                        readOnly/>
                            </div>
                        </th>
                        <th scope="row" className="w-[250px] py-1 pl-1 text-sm font-medium text-gray-800 whitespace-nowrap dark:text-gray-700">
                            <Tooltip disableFocusListener
                                     title={
                                <React.Fragment>
                                    {item.poster_link ?
                                    <img src={item.poster_link} alt={item.show_name}
                                         className='w-[200px]' />
                                    :
                                    <p className='w-[200px] h-[300px] pt-32 bg-white shadow-xl text-gray-500
                                                  text-center text-2xl font-extrabold italic'>{item.show_name}</p>
                                    }
                                </React.Fragment>
                            }>
                            <button size="small"
                                    className='text-left hover:cursor-pointer'>{item.show_name}</button>
                            </Tooltip>
                        </th>
                        <th scope="row" className="w-[200px] py-1 px-2.5 italic font-medium text-gray-500 whitespace-nowrap dark:text-gray-700">
                            {item.current_network_names ?
                             item.current_network_names.join(", ")
                             : ' '}
                        </th>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
     );
}

export default ResultList;